module.exports = __webpack_public_path__ + "assets/img/chevron-down-dark.c66b213d.svg";